// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useCanAccess as raUseCanAccess } from '@react-admin/ra-rbac';

import { PermissionActionT } from '@Common/types/bo/authorization';
import { BOResourceAll } from '@Common/types/bo_external/resources';

interface UseCanAccessParams {
  readonly resource: BOResourceAll;
  readonly action: PermissionActionT;
}

export function useCanAccess(params: UseCanAccessParams): boolean {
  const { canAccess, isLoading } = raUseCanAccess(params);

  return !isLoading && canAccess;
}
